import { canUseDOM } from 'exenv';

export default function loadComscoreTracker() {
  if (canUseDOM) {
    window.Nielsen_Event();
  }
}



// WEBPACK FOOTER //
// ./src/client/utils/third_party_trackers/nielsen.js